import api from './api';

const initialBalanceService = {
  create: async (data) => {
    const response = await api.post('/initial-balance', data);
    return response.data;
  },

  getCurrentBalance: async () => {
    const response = await api.get('/initial-balance');
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/initial-balance/${id}`, data);
    return response.data;
  }
};

export default initialBalanceService; 